module.exports = "<div class=social-facebook-button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/apps/observatoire/ng/social/obsSocialFacebookButton.html
// module id = 3580
// module chunks = 12